var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, InsertLinkOutlined } from "@mui/icons-material";
import { LinearProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNewNotification, showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { isLoadingState } from "../../../utils/utils";
import { BranchToBranchInwardPartDetails } from "../components/branchToBranchInwardPartDetails";
import { branchListGet, branchToBranchInwardAttachmentDelete, branchToBranchInwardCreate, BToBRequisitionIdAPICall, BToBShippingMethodListAPICall, BToBTransporterNameListAPICall, getBranchToBranchInward, OrganizationModulesItemSettingAPI, priorityListGet, uploadBranchToBranchInwardAttachment } from "../services/apiCalls";
import { BranchInwardApiKeys, BranchToBranchInwardAPIKeys, BranchToBranchMandatoryInwardFields } from "../services/entity";
function CreateBranchToBranchInward() {
    var _this = this;
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$BranchToBranchI, _crud$profilePersonal4, _crud$profilePersonal5;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var crud = useSelector(function (state) { return state.crud; });
    var _a = useState(0), grandTotal = _a[0], setGrandTotal = _a[1];
    var _b = useState(0), totalQuantity = _b[0], setTotalQuantity = _b[1];
    var dispatch = useDispatch();
    var id = useParams().id;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isDisabled = mode == 'edit';
    var branchToBranchInwardGetById = useAppSelector(function (state) { return state.crud; }).branchToBranchInwardGetById;
    useEffect(function () {
        getBranchList();
    }, []);
    var getBToBRequistionList = function (params) { return BToBRequisitionIdAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: {
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            Key: 'Completed',
            Type: 'BToBOutward'
        }
    })); };
    var getBranchList = function () {
        var _crud$profilePersonal;
        return branchListGet({
            request: {
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.Branches[0]) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.ParentOrganizationId
            }
        });
    };
    var branchList = function (params) {
        var _crud$profilePersonal2;
        return branchListGet(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.Branches[0]) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.ParentOrganizationId
            })
        }));
    };
    var getTransporterNameList = function (params) {
        var _crud$profilePersonal3;
        return BToBTransporterNameListAPICall(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                OrganizationTypeGroup: 10,
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal3 = crud.profilePersonalDetails) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.data) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.Branches[0]) === null || _crud$profilePersonal3 === void 0 ? void 0 : _crud$profilePersonal3.ParentOrganizationId
            })
        }));
    };
    var handleSearchClick = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBranchToBranchInward({
                        request: {
                            id: value === null || value === void 0 ? void 0 : value.id
                        }
                    })];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && result.data) {
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                    }
                    else {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "No requisition found",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var General = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'ParentId',
                    label: 'Transfer outward ID',
                    required: true,
                    placeholder: 'Select branch to branch requisition no',
                    valueExpr: "id",
                    displayExpr: "DocumentCode",
                    getListData: getBToBRequistionList,
                    options: (_crud$BranchToBranchI = crud[BranchToBranchInwardAPIKeys.RequisitionList]) === null || _crud$BranchToBranchI === void 0 || (_crud$BranchToBranchI = _crud$BranchToBranchI.data) === null || _crud$BranchToBranchI === void 0 ? void 0 : _crud$BranchToBranchI.filter(function (data) { return data === null || data === void 0 ? void 0 : data.id; }),
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var _data$SourceTenant, _data$DestinationTena, _data$TransportDetail, _data$TransportDetail2, _data$TransportDetail3, _data$TransportDetail4, data, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleSearchClick(currValue)];
                                case 1:
                                    data = _a.sent();
                                    return [4 /*yield*/, OrganizationModulesItemSettingAPI({
                                            request: {
                                                Key: "AllowInwardPartiallySave",
                                                OrganizationId: data.DestinationTenantId,
                                                ParentOrganizationId: data.DestinationParentTenantId
                                            }
                                        })];
                                case 2:
                                    result = _a.sent();
                                    return [2 /*return*/, {
                                            SourceWarehouseId: data === null || data === void 0 ? void 0 : data.SourceWarehouseId,
                                            DestinationWarehouseId: data === null || data === void 0 ? void 0 : data.SourceWarehouseId,
                                            PriorityId: data.PriorityId,
                                            StockTransferRequisitionDetail: data === null || data === void 0 ? void 0 : data.StockTransferRequisitionDetail,
                                            SourceTenantId: data === null || data === void 0 || (_data$SourceTenant = data.SourceTenant) === null || _data$SourceTenant === void 0 ? void 0 : _data$SourceTenant.id,
                                            DestinationTenantId: data === null || data === void 0 || (_data$DestinationTena = data.DestinationTenant) === null || _data$DestinationTena === void 0 ? void 0 : _data$DestinationTena.id,
                                            TransporterId: data === null || data === void 0 || (_data$TransportDetail = data.TransportDetail) === null || _data$TransportDetail === void 0 ? void 0 : _data$TransportDetail.TransporterId,
                                            ShippingMethodId: data === null || data === void 0 || (_data$TransportDetail2 = data.TransportDetail) === null || _data$TransportDetail2 === void 0 ? void 0 : _data$TransportDetail2.ShippingMethodId,
                                            ShippingDocumentDate: data === null || data === void 0 || (_data$TransportDetail3 = data.TransportDetail) === null || _data$TransportDetail3 === void 0 ? void 0 : _data$TransportDetail3.ShippingDocumentDate,
                                            ShippingDocumentNo: data === null || data === void 0 || (_data$TransportDetail4 = data.TransportDetail) === null || _data$TransportDetail4 === void 0 ? void 0 : _data$TransportDetail4.ShippingDocumentNo,
                                            BoxQuantity: data === null || data === void 0 ? void 0 : data.BoxQuantity,
                                            FiscalYearId: data === null || data === void 0 ? void 0 : data.FiscalYearId,
                                            FiscalPeriodId: data === null || data === void 0 ? void 0 : data.FiscalPeriodId,
                                            SourceParentTenantId: data === null || data === void 0 ? void 0 : data.SourceParentTenantId,
                                            DestinationParentTenantId: data === null || data === void 0 ? void 0 : data.DestinationParentTenantId,
                                            StockTransferTypeId: data === null || data === void 0 ? void 0 : data.StockTransferTypeId,
                                            TotalDamageQuantity: data === null || data === void 0 ? void 0 : data.TotalDamageQuantity,
                                            TotalExcessQuantity: data === null || data === void 0 ? void 0 : data.TotalExcessQuantity,
                                            isPartialSave: result.data.Value
                                        }];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "SourceTenantId",
                    label: "Source branch",
                    required: true,
                    disabled: true,
                    getListData: branchList
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DestinationTenantId",
                    label: "Destination branch",
                    required: true,
                    disabled: true,
                    getListData: branchList
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    getListData: priorityListGet,
                    disabled: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ScheduleTransportDate',
                    label: 'Schedule for transport',
                    disabled: true
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Logistic details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'TransporterId',
                    label: 'Transporter name',
                    placeholder: 'Select transporter name',
                    required: true,
                    valueExpr: "id",
                    displayExpr: "Name",
                    getListData: getTransporterNameList,
                    disabled: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ShippingMethodId',
                    label: 'Shipping method',
                    placeholder: 'Select shipping method',
                    required: true,
                    valueExpr: "id",
                    displayExpr: "Name",
                    getListData: BToBShippingMethodListAPICall,
                    disabled: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ShippingDocumentDate',
                    label: 'Shipping doc date',
                    disabled: true,
                    required: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'ShippingDocumentNo',
                    label: 'Shipping doc number',
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'VehicleNo',
                    label: 'Vehicle number',
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PermitNo',
                    label: 'Road permit number',
                    placeholder: 'Enter road permit number',
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'BoxQuantity',
                    label: 'No. of boxes',
                    placeholder: 'Enter no. of boxes',
                    disabled: true
                }]
        }];
    var PartDetails = [{
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            element: BranchToBranchInwardPartDetails,
            columnSize: 12,
            labelTypographyProps: {
                display: 'none'
            },
            validator: function (rows, state) {
                console.log("state", state);
                var error = undefined;
                if (!(rows !== null && rows !== void 0 && rows.length)) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: 'Please add part details',
                        type: "error"
                    }));
                    return 'Please add part details';
                }
                if (!(state !== null && state !== void 0 && state.isPartialSave)) {
                    rows.find(function (r) {
                        var errorField = Object.keys(BranchToBranchMandatoryInwardFields).find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                        if (errorField) {
                            error = {
                                id: v4(),
                                rowId: r.id,
                                field: BranchToBranchMandatoryInwardFields[errorField],
                                message: 'This field is required',
                                value: r[errorField]
                            };
                        }
                        return Boolean(errorField);
                    });
                    return error;
                }
            }
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'flex-end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'GrandTotal',
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                sx: {
                                    flexGrow: 1
                                },
                                fontWeight: "bold",
                                textAlign: "left"
                            }, "Grand Total"),
                            variant: 'outlined',
                            md: 4,
                            fullWidth: true,
                            sx: {
                                justifyContent: 'space-between',
                                bgcolor: 'rgba(0,0,0,0.05)',
                                fontWeight: 'bold',
                                color: systemColor.secondary
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$StockTran, _formValues$StockTran2, _totalAmt$toFixed;
                                var totalAmt = formValues === null || formValues === void 0 || (_formValues$StockTran = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran === void 0 ? void 0 : _formValues$StockTran.reduce(function (acc, data) {
                                    return acc + (data.PurchasePrice * data.RequestedQuantity || 0);
                                }, 0);
                                setGrandTotal(totalAmt);
                                var totalQty = formValues === null || formValues === void 0 || (_formValues$StockTran2 = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran2 === void 0 ? void 0 : _formValues$StockTran2.reduce(function (acc, data) {
                                    return acc + data.RequestedQuantity;
                                }, 0);
                                setTotalQuantity(totalQty);
                                return {
                                    type: this.type,
                                    startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ChevronRightRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null),
                                    endIcon: "\u20B9 ".concat((_totalAmt$toFixed = totalAmt === null || totalAmt === void 0 ? void 0 : totalAmt.toFixed(2)) !== null && _totalAmt$toFixed !== void 0 ? _totalAmt$toFixed : '00.00')
                                };
                            },
                            setFormState: function (formValues, e, field) {
                                return {
                                    Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                                };
                            }
                        }]
                }]
        }];
    var AdditionalInformation = [{
            type: FormItemTypes.CardComponent,
            name: 'AdditionalInfo',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'TotalTransporterCharges',
                    label: 'Total transporter charges',
                    placeholder: 'Total transporter charges',
                    disabled: true,
                    md: 4
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 2,
                    marginTop: 0,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'TransferReason',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            md: 6,
                            multiline: true,
                            maxLength: 200,
                            minRows: 2
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            disabled: false,
                            value: null,
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: BranchToBranchInwardAPIKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadBranchToBranchInwardAttachment,
                            deleteAttachmentAPI: branchToBranchInwardAttachmentDelete
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General
        }, {
            id: '1',
            label: 'Part details',
            elements: PartDetails
        }, {
            id: '2',
            label: 'Additional information',
            elements: AdditionalInformation
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "flex-start",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            flexWrap: 'nowrap',
            p: 2,
            width: '100%',
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () {
                            navigate('/branchToBranchInward');
                        }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: mode == 'edit' ? 'Edit Branch to branch inward' : 'New branch to branch inward',
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true,
                    textOverflow: 'ellipsis'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 0,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingX: 2,
                py: 1,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(Stack, null, isLoadingState(BranchInwardApiKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        formProps: {
            bgcolor: faintblue
        },
        getFormAPI: getBranchToBranchInward,
        getKey: BranchToBranchInwardAPIKeys.get,
        getRequest: {
            id: id
        },
        createKey: BranchToBranchInwardAPIKeys.create,
        createFormAPI: branchToBranchInwardCreate,
        createRequest: {
            Remarks: '',
            RejectRemarks: '',
            TotalQuantity: totalQuantity,
            TotalAmount: grandTotal,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal4 = crud.profilePersonalDetails) === null || _crud$profilePersonal4 === void 0 || (_crud$profilePersonal4 = _crud$profilePersonal4.data) === null || _crud$profilePersonal4 === void 0 ? void 0 : _crud$profilePersonal4.IdentityId,
            DocumentDate: new Date().toISOString(),
            Type: "BToBInward"
        },
        updateFormAPI: branchToBranchInwardCreate,
        updateKey: BranchToBranchInwardAPIKeys.update,
        updateRequest: {
            Remarks: '',
            RejectRemarks: '',
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal5 = crud.profilePersonalDetails) === null || _crud$profilePersonal5 === void 0 || (_crud$profilePersonal5 = _crud$profilePersonal5.data) === null || _crud$profilePersonal5 === void 0 ? void 0 : _crud$profilePersonal5.IdentityId,
            DocumentDate: new Date().toISOString(),
            Type: "BToBInward"
        },
        onClose: function () {
            dispatch(showNewNotification({
                isOpen: true,
                message: 'Save Successfully',
                type: 'success'
            }));
            navigate(-1);
        }
    }));
}
export default CreateBranchToBranchInward;
